<template>
    <div>
        <el-form :model="domainInfo" ref="ruleForm" label-width="140px" class="demo-ruleForm">
            <el-form-item label="网域：" prop="page" class="pageSelect" require>
                <el-input placeholder="网域" type="text" v-model="domainInfo.domain" @change="setMsg"></el-input>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    export default {
        props:['domainMsg'],
        data () {
            return {
                domainInfo:{...this.domainMsg}
            }
        },
        components:{
        },
        methods: {
            setMsg(){
                this.$emit('getDomainMsg',this.domainInfo)
            },
        },
        watch: {
            domainMsg:{
                handler(){
                    this.domainInfo = {...this.domainMsg}
                },
                deep:true
            },
        }
    }
</script>
<style lang="scss">
    
</style>